import { render, staticRenderFns } from "./DisbursementData.vue?vue&type=template&id=0e48041f&"
import script from "./DisbursementData.vue?vue&type=script&lang=js&"
export * from "./DisbursementData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports